// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dyxp","left":"styles_left__183nd"};